import React from 'react';
import BusinessUnitAdmin from 'components/commercetools-ui/business-unit/admin';

export const BusinessUnit = () => {
  return <BusinessUnitAdmin />;
};
